/**
 * Route Configuration
 * 
 * Configuración centralizada de rutas de la aplicación
 */

export const ROUTES = {
  HOME: '/',

  // Auth
  LOGIN: '/login',
  SIGNUP: '/signup',

  // Analytics (standalone module)
  ANALYTICS_SUMMARY: '/analytics',

  // Budget Allocation (standalone module)
  BUDGET_ALLOCATION: '/budget-allocation',

  // Creatives (standalone module)
  CREATIVES: '/creatives',
  CREATIVES_ANALYSIS: '/creatives/analysis',

  // Settings
  SETTINGS: {
    META_CONFIG: '/settings/meta',
  },


  // Profile
  PROFILE: '/profile',

  // Store Module (legacy - e-commerce)
  STORE: {
    HOME: '/store',
    PRODUCTS: '/store/products',
    PRODUCT_DETAIL: (id: string) => `/store/products/${id}`,
    CART: '/store/cart',
    CHECKOUT: '/store/checkout',
  },

  // Stores Module (Next Stores management)
  STORES: {
    HOME: '/stores',
  },

  // Agents Module
  AGENTS: {
    HOME: '/agents',
    MY_AGENTS: '/agents/my-agents',
    MARKET: '/agents/market',
    BUILDER: '/agents/builder',
    LIST: '/agents/list',
    DETAIL: (id: string) => `/agents/${id}`,
    CONVERSATIONS: '/agents/conversations',
  },

  // Marketing Module
  MARKETING: {
    HOME: '/marketing',
    ONBOARDING: '/marketing-onboarding',
    SUMMARY: '/marketing/summary',
    CAMPAIGNS: '/marketing/campaigns',
    CREATIVES: '/marketing/creatives',
    PROMOTIONS: '/marketing/promotions',
    ANALYTICS: '/marketing/analytics',
    // TikTok Intelligence
    TIKTOK_INTEL: '/marketing/tiktok-intel',

    // Research
    RESEARCH: {
      ADS: '/marketing/research/ads',
      SAVED_ADS: '/marketing/research/saved-ads',
      BRANDS: '/marketing/research/brands',
    },
    // AI Playground
    PLAYGROUND: {
      SWIPE: '/marketing/playground/swipe',
      STORYBOARD: '/marketing/playground/storyboard',
      CREATOR_EVALUATOR: '/marketing/playground/creator-evaluator',
    },
    // AI Chats
    CHATS: {
      HOME: '/marketing/chats',
      AD_CHIEF: '/marketing/chats/ad-chief',
      COPY_CHIEF: '/marketing/chats/copy-chief',
      AD_ANALYZER: '/marketing/chats/ad-analyzer',
    },
    // Repository
    REPOSITORY: {
      FOOTAGE: '/marketing/repository/footage',
      CREATORS: '/marketing/repository/creators',
    },
    // Debug
    DEBUG: {
      BRAND_CONTEXT: '/marketing/debug/brand-context',
    },
  },

  // Admin Module
  ADMIN: {
    ORGANIZATION: {
      HOME: '/admin/organization',
      ORGCHART: '/admin/organization/orgchart',
      ROLES: '/admin/organization/roles',
      PEOPLE: '/admin/organization/people',
    }
  },

  // Billing Module
  BILLING: {
    HOME: '/billing',
  },

  // My Company Module
  MY_COMPANY: {
    HOME: '/my-company',
    BRANDS: '/my-company/brands',
    STORES: '/my-company/stores',
    DOMAINS: '/my-company/domains',
    COMPETITORS: '/my-company/competitors',
    BENCHMARKS: '/my-company/benchmarks',
  },

  // Funnels Module
  FUNNELS: {
    HOME: '/funnels',
    DASHBOARD: '/funnels/dashboard',
    DETAIL: (id: string) => `/funnels/${id}`,
    OFFERS: '/funnels/offers',
    ANALYTICS: '/funnels/analytics',
    CHANGELOG: '/funnels/changelog',
    ALERTS: {
      HOME: '/funnels/alerts',
      RULES: '/funnels/alerts/rules',
    },
  },
} as const





